import React from 'react'
import PropTypes from 'prop-types'
import InputField from 'components/molecules/input-field'
import InputGroupField from 'components/molecules/input-group-field'
import { DATATYPE } from 'domains/product-attribute/constants'
import SelectField from 'components/molecules/select-field'
import CurrencyInputField from 'components/molecules/currency-input-field'
import { useFormikContext } from 'formik'


const propTypes = {
  name     : PropTypes.string.isRequired,
  code     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool,
  unit     : PropTypes.string,
  datatype : PropTypes.string,
  formText : PropTypes.string
}

const booleanOptions = [
  {
    label : 'Yes',
    value : true
  },
  {
    label : 'No',
    value : false
  }
]

/**
 * Render only field for Product Attribute that does not have reference table.
 * It will render based on data type.
 *
 * This component only used for `ProductAttributeDynamicForm`
 * @param {string} name - Formik name
 * @param {string} code - Product Attribute code
 * @param {string} label - Product Attribute label
 * @param {bool} required - Product Attribute curation field required
 * @param {bool} datatype - Product Attribute datatype
 */
const ProductAttributeDatatypeFields = ({
  name,
  code,
  label,
  unit,
  required,
  datatype,
  formText
}) => {
  const { values } = useFormikContext()

  switch (datatype) {
    case DATATYPE.BOOLEAN:
      return (
        <SelectField
          name={ name }
          label={ label }
          required={ required }
          placeholder={ 'Yes / No' }
          defaultValue={ booleanOptions.find((option) => option.value === values[code]) }
          defaultOptions={ booleanOptions }
          formText={ formText }
        />
      )
    case DATATYPE.DATE:
      return (
        <InputField
          key={ `product-attribute-datatype-fields-${code}` }
          type={ datatype }
          name={ name }
          label={ label }
          required={ required }
          formText={ formText }
        />
      )

    case DATATYPE.INTEGER:
    case DATATYPE.DECIMAL:
      if (unit) {
        return (
          <InputGroupField
            key={ `product-attribute-datatype-fields-${code}` }
            type='number'
            addonType='append'
            name={ name }
            label={ label }
            required={ required }
            inputGroupText={ unit }
            formText={ formText }
          />
        )
      }
      else {
        return (
          <InputField
            key={ `product-attribute-datatype-fields-${code}` }
            type='number'
            name={ name }
            label={ label }
            required={ required }
            formText={ formText }
          />
        )
      }

    case DATATYPE.PRICE:
      return (
        <CurrencyInputField
          key={ `product-attribute-datatype-fields-${code}` }
          name={ name }
          label={ label }
          required={ required }
          formText={ formText }
        />
      )

    default:
      return (
        <InputField
          key={ `product-attribute-datatype-fields-${code}` }
          type={ datatype }
          name={ name }
          label={ label }
          required={ required }
          formText={ formText }
        />
      )
  }
}

ProductAttributeDatatypeFields.propTypes = propTypes

export default ProductAttributeDatatypeFields
